import {
    OPENED_IMAGE_UPLOADER,
    CLOSED_IMAGE_UPLOADER,
    IMAGE_UPLOADER_VIEW_CHANGED,
    GIF_SEARCH_VALUE_CHANGED,
    GIFS_CHANGED,
    GIF_SEARCH_ERROR_CHANGED,
    STOCK_IMAGE_SEARCH_VALUE_CHANGED,
    STOCK_IMAGES_CHANGED,
    STOCK_IMAGE_SEARCH_ERROR_CHANGED,
    STOCK_IMAGE_NAV_VALUE_CHANGED,
    IMAGE_UPLOADER_CONFIG_CHANGED,
    STARTED_UPLOADING_IMAGE,
    UPLOAD_IMAGE_ERROR_THROWN,
    FINISHED_UPLOADING_IMAGE,
} from '../constants/actionTypes';

export const openImageUploader = () => (dispatch, getState) => {
    dispatch({
        type: OPENED_IMAGE_UPLOADER,
    });
};

export const setImageUploaderTab = (imageUploaderTab) => ({
    type: IMAGE_UPLOADER_VIEW_CHANGED,
    imageUploaderTab,
});

export const setGifSearchValue = (gifSearchValue) => ({
    type: GIF_SEARCH_VALUE_CHANGED,
    gifSearchValue,
});

export const setGifs = (gifs) => ({
    type: GIFS_CHANGED,
    gifs,
});

export const setGifSearchError = (gifSearchError) => ({
    type: GIF_SEARCH_ERROR_CHANGED,
    gifSearchError,
});

export const setStockImageSearchValue = (stockImageSearchValue) => ({
    type: STOCK_IMAGE_SEARCH_VALUE_CHANGED,
    stockImageSearchValue,
});

export const setStockImages = (stockImages) => ({
    type: STOCK_IMAGES_CHANGED,
    stockImages,
});

export const setStockImageSearchError = (stockImageSearchError) => ({
    type: STOCK_IMAGE_SEARCH_ERROR_CHANGED,
    stockImageSearchError,
});

export const setStockImageNavValue = (stockImageNavValue) => ({
    type: STOCK_IMAGE_NAV_VALUE_CHANGED,
    stockImageNavValue,
});

export const closeImageUploader = () => (dispatch, getState) => {
    dispatch({
        type: CLOSED_IMAGE_UPLOADER,
    });
};

export const setConfig = (config) => ({
    type: IMAGE_UPLOADER_CONFIG_CHANGED,
    config,
});

export const startImageUpload = () => ({
    type: STARTED_UPLOADING_IMAGE,
});

export const throwImageUploadError = (errorDescriptor) => ({
    type: UPLOAD_IMAGE_ERROR_THROWN,
    errorDescriptor,
});

export const finishImageUpload = () => ({
    type: FINISHED_UPLOADING_IMAGE,
});
